import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex flex-col text-left mt-2 rounded-lg border border-gray-200 p-4" }
const _hoisted_5 = { class: "flex flex-row items-center justify-between" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex flex-col justify-center" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col mt-2"
}
const _hoisted_10 = { class: "flex flex-col mt-4 items-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpertTagsList = _resolveComponent("ExpertTagsList")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        innerHTML: _ctx.TAGS_ICON,
        class: "text-primary-purple w-6 h-6"
      }, null, 8, _hoisted_3),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex flex-col" }, [
        _createElementVNode("div", { class: "text-black font-inter text-base font-semibold normal-case leading-6" }, " Expert Tags ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-col" }, [
          _createElementVNode("span", { class: "text-black text-md font-medium text-sm" }, "Expert Tags")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex items-center w-11 h-6 rounded-full transition-colors duration-300", {
                  'bg-violet-600': _ctx.showExpertTagsList,
                  'bg-gray-200': !_ctx.showExpertTagsList,
                }]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePayoutSetting && _ctx.togglePayoutSetting(...args))),
                "aria-label": "Toggle button"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["flex self-stretch my-auto w-4 h-4 bg-white rounded-full transition-transform duration-300 transform", {
                    'translate-x-6': _ctx.showExpertTagsList,
                    'translate-x-1': !_ctx.showExpertTagsList,
                  }])
                }, null, 2)
              ], 2)
            ])
          ])
        ])
      ]),
      (_ctx.showExpertTagsList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_ExpertTagsList, {
              modelValue: _ctx.listOfexpertTags,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listOfexpertTags) = $event)),
              showTitle: false
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_BaseButton, {
          type: "button",
          onClick: _ctx.handleUpdateClick,
          class: "px-4 py-2 text-xs max-w-max font-medium leading-none border border-gray-300 rounded-md text-white bg-primary-purple"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Save Changes ")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}